import React from 'react';

export default function Footer() {
  return (
    <footer>
      <p>
        Data courtesy of Australian Super. Source: Deloitte Average Balances to
        30 June 2025, rounded to the nearest $100. People with zero
        superannuation are not included in average data.
      </p>
    </footer>
  );
}
